const React = require('react');
require('./service-bell.scss');

const classnames = require('classnames');
const Dialog = require('../../../component/mui/dialog/dialog.jsx');
const Toast = require('../../../component/mui/toast.jsx');
const helper = require('../../../helper/common-helper.js');
import FormattedMessage from '../../../intl/formatted-message';
import { formatMessage } from '../../../intl/helper';
import errorMessages from '../../../intl/messages/error-message';
import dishMenuMessages from '../../../intl/messages/dish-menu';

const ServiceBell = React.createClass({
  displayName: 'ServiceBell',
  propTypes: {
    enableCallService: React.PropTypes.bool,
    animate: React.PropTypes.string,
    callBell: React.PropTypes.func.isRequired,
    clearBell: React.PropTypes.func.isRequired,
    callMsg: React.PropTypes.object.isRequired,
    expandMenu: React.PropTypes.bool.isRequired,
    callAble: React.PropTypes.bool.isRequired,
    cancelCallMsg: React.PropTypes.func,
    updateCanCall: React.PropTypes.func,
    tableInfo: React.PropTypes.object.isRequired,
    serviceSupply: React.PropTypes.array,
    showErrMsgFunc: React.PropTypes.func,
  },

  getInitialState() {
    return {
      showBellList: false,
      contentCode: '',
      contentMsg: '',
    };
  },

  componentDidMount() {
    const { updateCanCall } = this.props;
    // 设置服务铃
    const time = sessionStorage.getItem('callBellTime');

    if (time && time > 0) {
      updateCanCall(false);
      helper.interValSetting(time, () => {
        updateCanCall(true);
      });
    }
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.callAble && nextProps.callAble !== this.props.callAble) {
      this.setState({ endStatus: true });
      this._timer = setTimeout(() => {
        this.setState({ endStatus: false });
      }, 1000);
    }
  },

  handleShowBellList() {
    const { clearBell, callAble, tableInfo, serviceSupply, enableCallService } = this.props;
    const tableId = helper.getUrlParam('tableId') || helper.getUrlParam('tableKey') || (tableInfo && (tableInfo.tableName || tableInfo.tableId));

    if (serviceSupply && serviceSupply.length === 0) {
      clearBell(formatMessage(errorMessages.noConfigServiceBellError));
      return;
    }

    if (!tableId || !enableCallService) {
      clearBell(formatMessage(errorMessages.noBindTableError));
      return;
    }

    if (!callAble) {
      clearBell(formatMessage(errorMessages.waiterIsComingError));
      return;
    }

    this.setState({ showBellList: true });
  },

  handleHideBellList() {
    this.setState({ showBellList: false, contentCode:'', contentMsg:'' });
  },

  handleCallBell(e) {
    const { contentCode, contentMsg } = this.state;
    const { callBell, showErrMsgFunc } = this.props;
    e.stopPropagation();
    e.preventDefault();

    if (!contentCode || !contentMsg) {
      showErrMsgFunc(formatMessage(errorMessages.chooseServiceError));
      return;
    }

    this.handleHideBellList();
    const time = sessionStorage.getItem('callBellTime') || 60;
    callBell(time, contentCode, contentMsg);
  },
  buildBellList() {
    const { contentCode, contentMsg } = this.state;
    const { serviceSupply } = this.props;
    const bellList = [].slice.call(serviceSupply || []).sort((a, b) => {
      return a.sort - b.sort;
    });

    return bellList.map((item, index) =>
      <div
        key={index}
        className={classnames('shortcut-bell-item o-fz--14', { 'shortcut-bell-item-active': contentCode === item.code && contentMsg === item.desc })}
        onTouchTap={() => this.setState({ contentCode: item.code, contentMsg: item.desc })}
      >
        {item.desc}
      </div>
    );
  },
  render() {
    const { showBellList } = this.state;
    const { callMsg, cancelCallMsg, serviceSupply, isFucBell } = this.props;
    return (
      <div className="shortcut-bell">
        {
          showBellList &&
            <Dialog
              hasTopBtnClose={false}
              title={formatMessage(errorMessages.chooseServiceError)}
              onClose={this.handleHideBellList}
              theme="sliver"
            >
              <div className="shortcut-bell-box" ref="bellBox">
                <div className="o-ta--l shortcut-bell-list">{this.buildBellList()}</div>
                <div className="shortcut-bell-sendouter">
                  <div className="shortcut-bell-send" onTouchTap={this.handleCallBell}>
                    <FormattedMessage {...dishMenuMessages.send} />
                  </div>
                </div>
              </div>
            </Dialog>
        }
        {
          !isFucBell && serviceSupply && serviceSupply.length ?
            <div className="shortcut-bell-button bg-grey" onTouchTap={this.handleShowBellList}>
              <span>
                <FormattedMessage {...dishMenuMessages.serviceBell} />
              </span>
            </div> : false
        }
        {
          isFucBell && serviceSupply && serviceSupply.length ? <div className="shortcut-bell-button-reset" onTouchTap={this.handleShowBellList}>
          </div> : false
        }
        {callMsg.info && <Toast errorMessage={callMsg.info} clearErrorMsg={cancelCallMsg} />}
      </div>
    );
  },
});

module.exports = ServiceBell;



// WEBPACK FOOTER //
// ./src/component/dish-menu/cart/service-bell.jsx